
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import Navigation from "../components/Navigation";
import Intro from "../components/Intro";
import About from "../components/About";
import Services from "../components/Services";
import Contact from "../components/Contact";
import PrivacyPolicy from "../components/PrivacyPolicy";
import CookieNotice from "../components/CookieNotice";
import LanguageSwitcher from "../components/LanguageSwitcher";
import BookingModal from "../components/BookingModal";
import ContactForm from "../components/ContactForm";

const Index = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  // We're hardcoding showOverlay to false, but keeping the state in case we need to re-enable it later
  const [showOverlay] = useState(false);
  const [showPrivacyButton, setShowPrivacyButton] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);
  const [prefilledCode, setPrefilledCode] = useState('');

  useEffect(() => {
    const bookingParam = searchParams.get('booking');
    const codeParam = searchParams.get('code');

    if (bookingParam === 'true') {
      setBookingOpen(true);
      if (codeParam) {
        setPrefilledCode(codeParam);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    const handleScroll = () => {
      // Check if user has scrolled to the bottom
      const isBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
      setShowPrivacyButton(isBottom);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Initial check in case the page is short
    handleScroll();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navigation>
      {/* Language Switcher */}
      <LanguageSwitcher />

      {/* Cookie Notice */}
      <CookieNotice />

      {showOverlay && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-md">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md mx-4 text-center relative animate-fadeIn">
            <img
              src="/images/omsorgsterapi-logo.png"
              alt="Omsorgsterapi Logo"
              className="w-20 h-20 mx-auto mb-4 rounded-full"
            />
            <h2 className="text-2xl font-bold text-[#006B5F] mb-4">
              {t('overlay.title')}
            </h2>
            <p className="text-gray-700 mb-4">
              {t('overlay.description').split('info@omsorgsterapi.dk')[0]}
              <a
                href="mailto:info@omsorgsterapi.dk"
                className="text-[#006B5F] hover:underline font-medium"
              >
                info@omsorgsterapi.dk
              </a>
              {t('overlay.description').split('info@omsorgsterapi.dk')[1]}
            </p>
          </div>
        </div>
      )}

      <main className="min-h-screen bg-white">
        <Intro
          onBookConversation={() => setBookingOpen(true)}
        />
        <About />
        <Services
          onBookConversation={() => setBookingOpen(true)}
          onRequestLecture={() => setContactFormOpen(true)}
        />
        <Contact />

        {/* Privacy policy at the bottom left - only show when scrolled to bottom */}
        {showPrivacyButton && (
          <div className="fixed bottom-4 left-4 z-10">
            <PrivacyPolicy />
          </div>
        )}
      </main>

      <BookingModal
        isOpen={bookingOpen}
        onClose={() => setBookingOpen(false)}
        serviceType="private"
        prefilledCode={prefilledCode}
      />

      <ContactForm
        isOpen={contactFormOpen}
        onClose={() => setContactFormOpen(false)}
        serviceType="lecture"
      />
    </Navigation>
  );
};

export default Index;
